import React from 'react';
import { useLocation } from 'react-router';
import LabelPhotoZoom from '../components/LabelPhotoZoom';
import { rotationDegrees } from '../components/LabelPhotoImage';
import { isProjectStoragePhoto, useAnnouncedTurn } from '../utils/labelPhotoWindow';

/** The window is told the file, not whether it is the upload or a converted copy of it. */
const FILE_TITLE = 'Open this photo file in a new tab, as stored and not turned, to zoom in or download it';

/**
 * FS-1079 — a label photo popped out of the console into its own window,
 * with the same zoom controls and turn, and no app chrome. It draws only
 * photos from the project's own photo storage, never an address someone put
 * in the link. Rotate stays in the console; a Rotate pressed there turns the
 * photo here too.
 */
const LabelPhotoWindowPage: React.FC = () => {
  const query = new URLSearchParams(useLocation().search);
  const src = query.get('src');
  const stored = src !== null && isProjectStoragePhoto(src);
  const degrees = useAnnouncedTurn(stored ? src : null, rotationDegrees(Number(query.get('turn'))));

  if (!stored) {
    return (
      <main className="p-6">
        <h1 className="text-lg font-semibold">Label photo</h1>
        <p role="alert" className="mt-2 text-sm text-status-error-foreground">
          This window shows only label photos from the project&apos;s photo storage, and the link it was opened with is not one.
        </p>
      </main>
    );
  }
  return (
    <main className="flex h-screen flex-col">
      <h1 className="shrink-0 border-b p-3 text-lg font-semibold">Label photo</h1>
      <LabelPhotoZoom src={src} alt="Label photo" degrees={degrees} fileTitle={FILE_TITLE} />
    </main>
  );
};

export default LabelPhotoWindowPage;
